import { FormattedMessage } from 'react-intl';
import NotBookedState from '@rio-cloud/rio-uikit/lib/es/NotBookedState';

export const DiagnosticsNotBookedState = () => {
    const features = [
        <>
            <div className="padding-10">
                <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.no_booked_state.features.1" />
            </div>
        </>,
        <>
            <div className="padding-10">
                <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.no_booked_state.features.2" />
            </div>
        </>,
        <>
            <div className="padding-10">
                <FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.no_booked_state.features.3" />
            </div>
        </>,
    ];

    return (
        <div className="width-70pct center-block">
            <NotBookedState
                headline={<FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.no_booked_state.headline.title" />}
                message={<FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.no_booked_state.headline.message" />}
                features={features}
                condensed
                outerClassName="margin-bottom-20"
            />
        </div>
    );
};
